import React, { Component } from 'react';
import classNames from 'classnames';
import LocaleReceiver from '../locale-provider/LocaleReceiver';
import { generateShowHourMinuteSecond } from '../time-picker';
import enUS from './locale/en_US';
import TimePickerPanel from '../rc-components/time-picker/Panel';
import { Size } from '../_util/enum';
import ConfigContext from '../config-provider/ConfigContext';
function getColumns({ showHour, showMinute, showSecond, use12Hours }) {
    let column = 0;
    if (showHour) {
        column += 1;
    }
    if (showMinute) {
        column += 1;
    }
    if (showSecond) {
        column += 1;
    }
    if (use12Hours) {
        column += 1;
    }
    return column;
}
export default function wrapPicker(Picker, defaultFormat) {
    var _a;
    return _a = class PickerWrapper extends Component {
            constructor() {
                super(...arguments);
                this.handleOpenChange = (open) => {
                    const { onOpenChange } = this.props;
                    onOpenChange(open);
                };
                this.handleFocus = (e) => {
                    const { onFocus } = this.props;
                    if (onFocus) {
                        onFocus(e);
                    }
                };
                this.handleBlur = (e) => {
                    const { onBlur } = this.props;
                    if (onBlur) {
                        onBlur(e);
                    }
                };
                this.savePicker = (node) => {
                    this.picker = node;
                };
                this.getDefaultLocale = () => {
                    const { locale } = this.props;
                    const result = {
                        ...enUS,
                        ...locale,
                    };
                    result.lang = {
                        ...result.lang,
                        ...(locale || {}).lang,
                    };
                    return result;
                };
                this.renderPicker = (locale, localeCode) => {
                    const { props } = this;
                    const { getPrefixCls } = this.context;
                    const { prefixCls = getPrefixCls('calendar'), inputPrefixCls = getPrefixCls('input') } = props;
                    const pickerClass = classNames(`${prefixCls}-picker`, {
                        [`${prefixCls}-picker-${props.size}`]: !!props.size,
                    });
                    const pickerInputClass = classNames(`${prefixCls}-picker-input`, inputPrefixCls, {
                        [`${inputPrefixCls}-lg`]: props.size === Size.large,
                        [`${inputPrefixCls}-sm`]: props.size === Size.small,
                        [`${inputPrefixCls}-disabled`]: props.disabled,
                    });
                    const pickerWrapperInputClass = classNames(`${inputPrefixCls}-wrapper`, {
                        [`${inputPrefixCls}-disabled`]: props.disabled,
                        [`${inputPrefixCls}-has-border`]: props.border,
                    });
                    const timeFormat = (props.showTime && props.showTime.format) || 'HH:mm:ss';
                    const rcTimePickerProps = {
                        ...generateShowHourMinuteSecond(timeFormat),
                        format: timeFormat,
                        use12Hours: props.showTime && props.showTime.use12Hours,
                    };
                    const columns = getColumns(rcTimePickerProps);
                    const timePickerCls = `${prefixCls}-time-picker-column-${columns}`;
                    const timePicker = props.showTime ? (React.createElement(TimePickerPanel, Object.assign({}, rcTimePickerProps, props.showTime, { prefixCls: `${prefixCls}-time-picker`, className: timePickerCls, placeholder: locale.timePickerLocale.placeholder, transitionName: "slide-up" }))) : null;
                    return (React.createElement(Picker, Object.assign({}, props, { ref: this.savePicker, pickerClass: pickerClass, pickerInputClass: pickerInputClass, pickerWrapperInputClass: pickerWrapperInputClass, locale: locale, localeCode: localeCode, timePicker: timePicker, onOpenChange: this.handleOpenChange, onFocus: this.handleFocus, onBlur: this.handleBlur })));
                };
            }
            static get contextType() {
                return ConfigContext;
            }
            componentDidMount() {
                const { autoFocus, disabled } = this.props;
                if (autoFocus && !disabled) {
                    this.focus();
                }
            }
            focus() {
                this.picker.focus();
            }
            blur() {
                this.picker.blur();
            }
            render() {
                return (React.createElement(LocaleReceiver, { componentName: "DatePicker", defaultLocale: this.getDefaultLocale }, this.renderPicker));
            }
        },
        _a.displayName = 'PickerWrapper',
        _a.defaultProps = {
            format: defaultFormat || 'YYYY-MM-DD',
            transitionName: 'slide-up',
            popupStyle: {},
            onChange() {
            },
            onOk() {
            },
            onOpenChange() {
            },
            locale: {},
            border: true,
        },
        _a;
}
